<lvr-heading>
	{{ 'client.relatives.title' | transloco }} {{ client()?.name
	}}{{ client()?.firstName ? ', ' + client()?.firstName : '' }}
	@if (client()?.dateOfBirth) {
		*{{ client()?.dateOfBirth | date: dateDisplayFormat }}
	}
</lvr-heading>

@if (canCreateRelatives()) {
	<lvr-button
		variant="primary"
		[label]="'client.relatives.personal_title' | transloco"
		[ariaLabel]="'client.relatives.add' | transloco"
		[type]="'button'"
		(clicked)="openCreate()"
		data-testid="add-button"
		icon="add"
	>
	</lvr-button>
}

<section lvrPadding [padHorizontal]="32" [padVertical]="0">
	<lvr-relatives-list
		[title]="'client.relatives.personal_title' | transloco"
		[relatives]="personalRelatives()"
	></lvr-relatives-list>
	@if (personalTotalItems() > 0) {
		<lvr-paginator
			[length]="personalTotalItems()"
			[pageSize]="personalPageSize()"
			[pageIndex]="personalPageIndex()"
			[showFirstLastButtons]="showFirstLastButtons"
			[hidePageSize]="hidePageSize"
			preferenceKey="client-relatives-personal"
			(page)="handlePersonalPageEvent($event)"
		></lvr-paginator>
	}
	<lvr-spacer [height]="32"></lvr-spacer>

	<div class="relatives-divider" aria-hidden="true"></div>

	<lvr-other-relatives-list
		[title]="'client.relatives.other_title' | transloco"
		[relatives]="otherRelatives()"
	></lvr-other-relatives-list>
	@if (otherTotalItems() > 0) {
		<lvr-paginator
			[length]="otherTotalItems()"
			[pageSize]="otherPageSize()"
			[pageIndex]="otherPageIndex()"
			[showFirstLastButtons]="showFirstLastButtons"
			[hidePageSize]="hidePageSize"
			preferenceKey="client-relatives-other"
			(page)="handleOtherPageEvent($event)"
		></lvr-paginator>
	}
</section>
